import { render, staticRenderFns } from "./file-preview-gallery-dialog.vue?vue&type=template&id=28381833"
import script from "./file-preview-gallery-dialog.vue?vue&type=script&lang=js"
export * from "./file-preview-gallery-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports